import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStaffRolesInfo(companyId, regulationId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAFF_ROLES_INFO,
		dtConfig[ModulesMap.REGULATIONS_STAFF_ROLES_INFO].getRegulationsStaffRolesInfo,
		{
			urlParams: {
				companyId,
				regulationId,
			},
		}
	)
}

export default {
	getRegulationsStaffRolesInfo,
}
